<mat-form-field appearance="outline" subscriptSizing="dynamic" class="monthpicker-field">
  <mat-label>{{ 'monthAndYear' | translate }}</mat-label>
  <input #monthInput matInput [matDatepicker]="dp" [formControl]="control" readonly />
  @if (allowClearSelection) {
    <span matSuffix class="monthpicker-suffix-actions">
      @if (control.value) {
        <button
          mat-icon-button
          type="button"
          class="monthpicker-clear"
          [matTooltip]="'clearMonthFilter' | translate"
          [attr.aria-label]="'clearMonthFilter' | translate"
          (click)="clearSelectionClick($event)"
        >
          <mat-icon class="monthpicker-clear__icon">close</mat-icon>
        </button>
      }
      <mat-datepicker-toggle [for]="dp"></mat-datepicker-toggle>
    </span>
  } @else {
    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
  }
  <mat-datepicker
    #dp
    startView="multi-year"
    panelClass="example-month-picker"
    (monthSelected)="setMonthAndYear($event, dp)"
  ></mat-datepicker>
</mat-form-field>
